module.exports = __webpack_public_path__ + "tenant-tagsets.5e11f1007ab476412ff61d06010b0afe.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/tenants/intro/tenant-tagsets.png
// module id = 1803094140813822
// module chunks = 1